export default __webpack_public_path__ + "static/media/canada-hs.91e563b6.svg";